// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\PersonProfilePage\PersonProfilePageViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { DefaultImage, DefaultImageData, DefaultImageOptions } from 'data/models/DefaultImage';
import { LandingPage, LandingPageData, LandingPageOptions } from 'data/models/LandingPage';
import { Notification, NotificationData, NotificationOptions } from 'data/models/Notification';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';
import { PersonProfilePageResponseRef as _PersonProfilePageResponseRef, PersonProfilePageResponseRefData as _PersonProfilePageResponseRefData, PersonProfilePageResponseRefOptions as _PersonProfilePageResponseRefOptions } from 'data/models/PersonProfilePageResponse';
import { Role, RoleData, RoleOptions } from 'data/models/Role';

// PersonProfilePageResponseData is the class that PersonProfilePageResponse serializes to/from
export interface PersonProfilePageResponseData {
    UserId : number;
	
    InvitablePortCallEditors : PCUserData[] | null;
    LandingPages : LandingPageData[] | null;
    Notifications : NotificationData[] | null;
    PCUser : PCUserData | null;
    Roles : RoleData[] | null;
	
    BookingRate : number | null;
    CanAdmin : boolean;
    CanChangePassword : boolean;
    CanMarkNotificationsAsViewed : boolean;
    Ref : _PersonProfilePageResponseRefData;
}

// PersonProfilePageResponseOptions is the class which may be passed to the PersonProfilePageResponse constructor to define optional initial data values
export interface PersonProfilePageResponseOptions {
    UserId : number;
	
    InvitablePortCallEditors? : PCUserOptions[] | null;
    LandingPages? : LandingPageOptions[] | null;
    Notifications? : NotificationOptions[] | null;
    PCUser? : PCUserOptions | null;
    Roles? : RoleOptions[] | null;
	
    BookingRate? : number | null;
    CanAdmin? : boolean;
    CanChangePassword? : boolean;
    CanMarkNotificationsAsViewed? : boolean;
    Ref? : _PersonProfilePageResponseRefOptions;
}

export class PersonProfilePageResponse {
    public UserId : DataSignal<number>;
	
    public InvitablePortCallEditors : SDataArray<PCUser>;
    public LandingPages : SDataArray<LandingPage>;
    public Notifications : SDataArray<Notification>;
    public PCUser : DataSignal<PCUser | null>;
    public Roles : SDataArray<Role>;
	
    public BookingRate : DataSignal<number | null>;
    public CanAdmin : DataSignal<boolean>;
    public CanChangePassword : DataSignal<boolean>;
    public CanMarkNotificationsAsViewed : DataSignal<boolean>;
    public Ref : _PersonProfilePageResponseRef;

    constructor();
    constructor(data : PersonProfilePageResponseOptions);
    constructor(data: PersonProfilePageResponseOptions | null = null) {
        this.UserId = jsonableObservable(S.value<number>(data && data.UserId !== undefined ? data.UserId : 0));
	    
        this.InvitablePortCallEditors = SArray<PCUser>([]);
        this.LandingPages = SArray<LandingPage>([]);
        this.Notifications = SArray<Notification>([]);
        this.PCUser = S.value<PCUser | null>(null);
        this.Roles = SArray<Role>([]);
	    
        this.BookingRate = jsonableObservable(S.value<number | null>(data && data.BookingRate !== undefined ? data.BookingRate : null));
        this.CanAdmin = jsonableObservable(S.value<boolean>(data && data.CanAdmin !== undefined ? data.CanAdmin : false));
        this.CanChangePassword = jsonableObservable(S.value<boolean>(data && data.CanChangePassword !== undefined ? data.CanChangePassword : false));
        this.CanMarkNotificationsAsViewed = jsonableObservable(S.value<boolean>(data && data.CanMarkNotificationsAsViewed !== undefined ? data.CanMarkNotificationsAsViewed : false));
        this.Ref = data && data.Ref !== undefined ? new _PersonProfilePageResponseRef(data.Ref) : new _PersonProfilePageResponseRef();
    }

    static key(obj : PersonProfilePageResponse) {
        return obj.UserId();
    }
    
    static dataKey(obj : PersonProfilePageResponseOptions) {
        return obj.UserId;
    }

    static update(obj : PersonProfilePageResponse, data : PersonProfilePageResponseOptions) {
        S.freeze(() => {
            if (data.UserId !== undefined) obj.UserId(data.UserId);
	        
	        
            if (data.BookingRate !== undefined) obj.BookingRate(data.BookingRate);
            if (data.CanAdmin !== undefined) obj.CanAdmin(data.CanAdmin);
            if (data.CanChangePassword !== undefined) obj.CanChangePassword(data.CanChangePassword);
            if (data.CanMarkNotificationsAsViewed !== undefined) obj.CanMarkNotificationsAsViewed(data.CanMarkNotificationsAsViewed);
            if (data.Ref !== undefined) _PersonProfilePageResponseRef.update(obj.Ref, data.Ref);
        });
    }
}

// PersonProfilePageResponseRefData is the class that PersonProfilePageResponseRef serializes to/from
export interface PersonProfilePageResponseRefData {
	
    DefaultImages : DefaultImageData[] | null;
	
    AllowedImageUploadExtensions : string[];
    MaximumImageUploadFileSize : number;
    MinimumImageUploadImageSize : number;
}

// PersonProfilePageResponseRefOptions is the class which may be passed to the PersonProfilePageResponseRef constructor to define optional initial data values
export interface PersonProfilePageResponseRefOptions {
	
    DefaultImages? : DefaultImageOptions[] | null;
	
    AllowedImageUploadExtensions? : string[];
    MaximumImageUploadFileSize? : number;
    MinimumImageUploadImageSize? : number;
}

export class PersonProfilePageResponseRef {
	
    public DefaultImages : SDataArray<DefaultImage>;
	
    public AllowedImageUploadExtensions : SDataArray<string>;
    public MaximumImageUploadFileSize : DataSignal<number>;
    public MinimumImageUploadImageSize : DataSignal<number>;

    constructor();
    constructor(data : PersonProfilePageResponseRefOptions);
    constructor(data: PersonProfilePageResponseRefOptions | null = null) {
	    
        this.DefaultImages = SArray<DefaultImage>([]);
	    
        this.AllowedImageUploadExtensions = jsonableObservable(SArray<string>(data && data.AllowedImageUploadExtensions !== undefined ? data.AllowedImageUploadExtensions : []));
        this.MaximumImageUploadFileSize = jsonableObservable(S.value<number>(data && data.MaximumImageUploadFileSize !== undefined ? data.MaximumImageUploadFileSize : 0));
        this.MinimumImageUploadImageSize = jsonableObservable(S.value<number>(data && data.MinimumImageUploadImageSize !== undefined ? data.MinimumImageUploadImageSize : 0));
    }

    static key(obj : PersonProfilePageResponseRef) {
        return ;
    }
    
    static dataKey(obj : PersonProfilePageResponseRefOptions) {
        return ;
    }

    static update(obj : PersonProfilePageResponseRef, data : PersonProfilePageResponseRefOptions) {
        S.freeze(() => {
	        
	        
            if (data.AllowedImageUploadExtensions !== undefined) obj.AllowedImageUploadExtensions(data.AllowedImageUploadExtensions);
            if (data.MaximumImageUploadFileSize !== undefined) obj.MaximumImageUploadFileSize(data.MaximumImageUploadFileSize);
            if (data.MinimumImageUploadImageSize !== undefined) obj.MinimumImageUploadImageSize(data.MinimumImageUploadImageSize);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PersonProfilePageResponse.ts